// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__-mJ3j"};